import {
  ADMINISTRATION_DASHBOARD_PATH,
  ADMINISTRATION_OFFERS_PATH,
  ADMINISTRATION_ORGANIZATIONS_PATH,
  ADMINISTRATION_PATH,
  ADMINISTRATION_USERS_PATH,
  GRAFANA_DASHBOARD_URL
} from 'configs';
import { useIsPlatformAdmin } from 'hooks/admin/useIsPlatformAdmin';
import { FC, useMemo } from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { NavLink, useLocation } from 'react-router';
import './AdministrationLocalNavigationBar.scss';

export const AdministrationLocalNavigationBar: FC = () => {
  const { pathname } = useLocation();
  const isPlatformAdmin = useIsPlatformAdmin();
  const { t } = useTranslation('translation', {
    keyPrefix: 'administrationPage'
  });

  const navigationItems = useMemo(() => {
    const items = [
      {
        to: ADMINISTRATION_USERS_PATH,
        label: t('menu.users')
      },
      {
        to: ADMINISTRATION_ORGANIZATIONS_PATH,
        label: t('menu.organizations')
      },
      {
        to: ADMINISTRATION_OFFERS_PATH,
        label: t('menu.offers')
      }
    ];

    if (GRAFANA_DASHBOARD_URL?.trim()) {
      items.push({
        to: ADMINISTRATION_DASHBOARD_PATH,
        label: t('menu.dashboard')
      });
    }

    return items;
  }, [t]);

  if (!isPlatformAdmin || !pathname.startsWith(ADMINISTRATION_PATH)) {
    return null;
  }

  return (
    <Navbar bg="subHeading" className="local-navigation">
      <Container className="local-navigation__desktop">
        <Nav className="local-navigation__nav justify-content-center flex-wrap">
          {navigationItems.map((item) => (
            <Nav.Link
              key={item.to}
              as={NavLink}
              to={item.to}
              title={item.label}
              className="text-center"
            >
              <span className="text-nowrap">{item.label}</span>
            </Nav.Link>
          ))}
        </Nav>
      </Container>
    </Navbar>
  );
};
